import { render, staticRenderFns } from "./KCPassUIView.vue?vue&type=template&id=a45640fa&"
import script from "./KCPassUIView.vue?vue&type=script&lang=js&"
export * from "./KCPassUIView.vue?vue&type=script&lang=js&"
import style0 from "./KCPassUIView.vue?vue&type=style&index=0&id=a45640fa&prod&lang=css&"
import style1 from "./KCPassUIView.vue?vue&type=style&index=1&id=a45640fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports